import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '@/lib/api';
import { storeReferralCode } from '@/lib/referral';
import ResqlyCard from '@/components/resqly/ResqlyCard';
import { Button } from '@/components/ui/button';

export default function ReferralLanding() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const normalized = (code || '').trim().toUpperCase();
    if (!normalized) {
      setError('Referral link is invalid');
      return;
    }
    storeReferralCode(normalized);
    api.get(`/referrals/validate/${encodeURIComponent(normalized)}`)
      .then(({ data }) => {
        if (!data.valid) {
          setError('This referral link is not valid');
          return;
        }
        setInfo(data);
      })
      .catch(() => setError('Unable to verify referral link'));
  }, [code]);

  const goCustomer = () => navigate('/consumer/login');
  const goRanger = () => navigate('/provider/login');

  return (
    <div className="resqly-shell min-h-screen bg-[var(--resqly-surface-muted)]">
      <div className="resqly-frame px-5 py-8">
        <ResqlyCard className="p-6 space-y-4" elevated>
          <h1 className="text-xl font-semibold text-slate-900">Join RESQLY</h1>
          {error ? (
            <p className="text-sm text-rose-600">{error}</p>
          ) : (
            <>
              <p className="text-sm text-slate-600">
                {info?.referrer_display_name
                  ? `${info.referrer_display_name} invited you to RESQLY.`
                  : 'You were invited to RESQLY.'}
              </p>
              <p className="text-xs text-slate-500">
                Your referral will be saved when you complete sign-up. Existing accounts cannot change their referrer.
              </p>
            </>
          )}
          <div className="flex flex-col gap-2 pt-2">
            <Button onClick={goCustomer} className="w-full">Continue as Customer</Button>
            <Button variant="outline" onClick={goRanger} className="w-full">Continue as RESQLY Ranger</Button>
          </div>
        </ResqlyCard>
      </div>
    </div>
  );
}
